import { ReactElement } from 'react';
import { Nullable } from '../../../../../../models';
import * as S from './emailSuggestion.styled';
import { EmailSuggestionModel } from './emailSuggestion.model';

export const EmailSuggestion = ({
  value,
  handleSuggestionClick,
}: EmailSuggestionModel): Nullable<ReactElement> => {
  if (!value) {
    return null;
  }

  return (
    <S.EmailSuggestion>
      Возможно, вы хотели указать{' '}
      <S.EmailSuggestionValue onClick={handleSuggestionClick.bind(null, value)}>
        {value}
      </S.EmailSuggestionValue>
    </S.EmailSuggestion>
  );
};
